<div class="grid-zone-container">

  <app-svg-converter #svgBackground
    *ngIf="svgSource"
    [svgSource]="svgSource"
    (backgroundLoaded)="handleAfterSVGLoaded($event)">
  </app-svg-converter>
  <ng-container *ngIf="backgroundWidth && backgroundHeight">
    <div class="zone-box-container"
      [style.width.px]="backgroundWidth"
      [style.height.px]="backgroundHeight"
      cdkDropListGroup>
      <div *ngFor="let item of items;let i=index"
        class="box-item"
        [ngClass]="{'dragging':isDragging}"
        [class.cdk-drag-preview]="keyboardDragSourceIndex !== null && keyboardDragTargetIndex === i"
        [class.keyboard-grabbed]="keyboardDragSourceIndex !== null && keyboardDragTargetIndex === i"
        [matTooltip]="getTooltipItem(i)?.configZoneName || ''"
        [matTooltipDisabled]="!getTooltipItem(i)"
        [matTooltipClass]="customTooltipClasses"
        matTooltipShowDelay="0"
        matTooltipHideDelay="0"
        #boxTooltip="matTooltip"
        [style.width.px]="calculateZoneBoxWidth(item)"
        [style.height.px]="zoneBoxHeight"
        #boxItemEl
        [attr.tabindex]="item.active ? 0 : -1"
        role="button"
        [attr.aria-grabbed]="keyboardDragSourceIndex !== null && keyboardDragTargetIndex === i"
        [attr.aria-disabled]="!getRenderedItem(i)"
        [attr.aria-label]="getBoxItemAriaLabel(i)"
        cdkDropList
        (mousedown)="onDragStart(item)"
        (mouseup)="onDragEnd()"
        (focus)="onBoxItemFocus(item, i, boxTooltip)"
        (blur)="onBoxItemBlur(boxTooltip)"
        (keydown)="onBoxItemKeydown($event, item, i, boxTooltip)"
        cdkDropListOrientation="horizontal"
        [cdkDropListData]="{item:item,index:i}"
        (cdkDropListDropped)="drop($event)">
        <div class="inner-content"
          [class.cdk-drag-dragging]="keyboardDragSourceIndex !== null && keyboardDragTargetIndex === i"
          cdkDrag
          [cdkDragDisabled]="!item.active"
          (cdkDragEnded)="onDragEnd()">
          <div class="box-placeholder"
            *cdkDragPlaceholder></div>
          <ng-container *ngIf="getRenderedItem(i) as rendered">
            <div class="box"
              [style.width.px]="zoneBoxWidth"
              [style.height.px]="zoneBoxHeight"
              (mouseenter)="onMouseEnter(item)"
              (mouseleave)="onMouseOut()">
              <div class="box-active"
                [ngClass]="{'box-duplicate': rendered.isDuplicate}"
                [style.width.px]="zoneBoxActiveSize"
                [style.height.px]="zoneBoxActiveSize">
                  <div class="box-name"
                    [style.height.px]="zoneBoxActiveSize"
                    [style.width.px]="zoneBoxActiveSize"
                    [style.lineHeight.px]="zoneBoxActiveSize">{{rendered.isDuplicate ? 'M' : rendered.name.slice(1)}}</div>
                  <div class="multiple-box-name"
                    *ngIf="rendered.isDuplicate">{{('MULTIPLE' | translate) + ' (' + rendered.name + ')'}}</div>
              </div>
             
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>
